import { connect } from 'react-redux';

import Overlay from './overlay.jsx';

import {
  setOverlayContentUuid
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';

import {
  getRenderAsMobile,
  getCssClassesListForOverlay,
  getIsActiveOverlayOpenedFromSlidehsow,
  getPreviewCollaborationSettings
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import { getRouter, getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

import { 
  isVideoish
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import { makeVideoishPlayerPropsForContent } from 'zoomforth_tools/videoish_player.js';

const mapStateToProps = (state, { contentItem, asset }) => {

  const { slideshowData } = contentItem;

  const renderAsMobile = getRenderAsMobile(state);
  const cssClassesListForOverlay = getCssClassesListForOverlay(state, contentItem);

  const { id, sources, subtitleTrack, posterImageUrl, canDownloadVideo } = 
    isVideoish(contentItem) ? makeVideoishPlayerPropsForContent(contentItem, asset) : {};

  const isOpenedFromSlideshow = getIsActiveOverlayOpenedFromSlidehsow(state);

  const previewCollaborationSettings = getPreviewCollaborationSettings(state);
  const isPreviewCollaborationEnabled = !!previewCollaborationSettings.isEnabled;

  const iframeWrapperProps = {};
  if(isPreviewCollaborationEnabled){
    iframeWrapperProps['data-velt-iframe-container'] = true;
  }

  var videoishPlayerId = id;

  // VideoJS wants each video object to have a unique ID. In the case of the
  // newer carousels we actually have the video in the site itself and the same
  // video in the overlay. We want to update the ID so this acts as a unique
  // reference.
  if (isOpenedFromSlideshow) {
    videoishPlayerId = `${id}-from-slideshow`;
  }

  return {
    renderAsMobile,
    cssClassesListForOverlay,
    isOpenedFromSlideshow,
    iframeWrapperProps,
    videoishPlayerProps: {
      id: videoishPlayerId,
      autoplay: true,
      sources,
      subtitleTrack,
      posterImageUrl,
      canDownloadVideo
    },
    slideshowData,
    isPreviewCollaborationEnabled
  };
};

const mapDispatchToProps = (dispatch, { currentSubpage, contentItem }) => {
  // if the back button gets used, the overlay will be closed as part of handling the subpage
  // that launched it (which is where the back button will go to).
  // The scroll location will _not_ be saved if the back button is used.
  return {
    onOverlayDisplay: ()=> {
      getRouter().navigateToOverlay(
        currentSubpage,
        contentItem.uuid, 
        {trigger:false, replace: false}
      );
    },
    onRequestClose: ()=> { 
      dispatch(setOverlayContentUuid(null));
      getRouter().navigateToSubpage(currentSubpage, {trigger:false, replace: false});
    },
    onPresentationSlideDisplay: (slideNum)=> {
      getTracker().handlePPTSlideDisplayed(contentItem.uuid, slideNum);
    },
    onPresentationDownloadClick: () => {
      getTracker().handlePPTDownloadClick(contentItem.uuid);
    },

    videoishPlayerProps: {
      onEnded: (eventData)=> {
        getTracker().handleOverlayVideoEnded(contentItem, eventData);
      },
      onError: (eventData)=> {
        getTracker().handleOverlayVideoError(contentItem, eventData);
      },
      onPause: (eventData)=> {
        getTracker().handleOverlayVideoPause(contentItem, eventData);
      },
      onPlay: (eventData)=> {
        getTracker().handleOverlayVideoPlay(contentItem, eventData);
      },
      onSeeked: (eventData)=> {
        getTracker().handleOverlayVideoSeeked(contentItem, eventData);
      },
      onStart: (eventData)=> {
        getTracker().handleOverlayVideoStart(contentItem, eventData);
      },
      onTimeUpdate: (eventData)=> {
        getTracker().handleOverlayVideoTimeUpdate(contentItem, eventData);
      }
    }
  };
};

const mergeProps = (propsFromState, propsFromDispatch, ownProps)=> {
  return ({
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
    videoishPlayerProps: { 
      ...propsFromState.videoishPlayerProps, 
      ...propsFromDispatch.videoishPlayerProps,
      ...ownProps.videoishPlayerProps
    }
  });
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Overlay);
